import {
  thirtyMinutesInSeconds,
  visitUuidCookieName,
} from "../../../constants";
import { OPT_IN_GROUP_VALUE } from "./AnalyticsService";
import { createCDMEvent, filterQueryParams } from "./AnalyticsEventBuilder";
import { getCookie, setCookie } from "../../utils/cookies";
import { EventCategoryEnum } from "./AnalyticsEventEnums";
import IAnalyticsService from "./IAnalyticsService";

import { ReservedValueStoreKeys } from "../JWeb/JWebEnums";
import { UuidV4 } from "../../utils/crypto";
import { writeDataToValueStore } from "../JWeb";
import { registerOptanonDataLayerEventHandler } from "../consentService/optanonUtils";

/** This is a sub service inside the Analytics Service that works in Web & Native. */
export default class VisitUuidHandler {
  private _analyticsService: IAnalyticsService | undefined;
  private _userActivityIdleTimeInSeconds;
  private _unblockVisitUUID: any;
  private _hasVisitUUIDCookie = false;

  public isVisitUUIDReady = new Promise((resolve, reject) => {
    this._unblockVisitUUID = { resolve, reject };
  });

  private _analyticsOptInGroup = OPT_IN_GROUP_VALUE;

  constructor(analyticsService: IAnalyticsService) {
    // without idle activity input type
    this._userActivityIdleTimeInSeconds = thirtyMinutesInSeconds; //fallback (30 minutes);
    this._analyticsService = analyticsService;
  }

  public async init(): Promise<void> {
    this._hasVisitUUIDCookie = !!getCookie(visitUuidCookieName, false);
    if (!this._hasVisitUUIDCookie) {
      await this.createAndSetVisitUUID();
      this._unblockVisitUUID.resolve();
      this.sendVisitContextRaw();
    } else {
      this._unblockVisitUUID.resolve();
      const hasWhitelist = this.checkWhiteList();
      if (hasWhitelist) {
        this.sendVisitContextRaw();
      }
    }
  }

  public checkWhiteList(): boolean {
    const queryParams = new URLSearchParams(window.location.search);
    const hasAttributionParameters =
      !!filterQueryParams(queryParams).whiteListed.length;
    return hasAttributionParameters;
  }

  /**
   * Publish the notification for Visit Context Raw via Analytics when called.
   */
  public publishVisitContextRawEvent(): void {
    const eventList = [createCDMEvent(EventCategoryEnum.visitContextRaw)];

    this._analyticsService?.publishCdmEvents(eventList);
  }

  /**
   * VisitContextRaw contains visitUUID + cokkies + queryParams
   */
  public async sendVisitContextRaw(): Promise<void> {
    //https://hp-jira.external.hp.com/browse/JSHELL-2915
    // Rule: adding to banner queue only becasue isn't necessary
    // create a new visit UUID

    // The new visitUUID will be sent via analytics Service
    const sendVisitContextRawOnOptIn = {
      event: "pb.onOptIn",
      callback: this.publishVisitContextRawEvent.bind(this),
      groups: this._analyticsOptInGroup,
      type: [1],
      jarvisHandlerType: "visitContextRawHandler",
    };

    registerOptanonDataLayerEventHandler(sendVisitContextRawOnOptIn);
  }

  /**
   * It creates and adds a newVisitUuid to Cookies (for browser) and in
   * ValueStore (on Jweb).
   */
  public async createAndSetVisitUUID(): Promise<void> {
    // Rule: Is necessary a create a new visit UUID before adding in banner
    // Optanon Data Layer.

    const newVisitUuid = UuidV4.getRandomUUID();

    // setting for Browser
    setCookie(
      visitUuidCookieName,
      newVisitUuid,
      this._userActivityIdleTimeInSeconds.toString(),
      false
    );

    // setting for JWeb
    await writeDataToValueStore([
      {
        key: ReservedValueStoreKeys.visitUuid,
        value: newVisitUuid,
      },
    ]);
  }
}
